/**
 * Created by staffanrantzow on 15/03/16.
 */

/* @flow */
import React, {PropTypes } from 'react';
import { Link } from 'react-router';
import Translate from 'react-translate-component';
import PageTitle from './page-title';
import Velocity from 'velocity-animate';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';
import * as variables from 'frilans-finans/variables';

let previousWidth = window.innerWidth;
const NO_TRANSLATION = ' ';

export class SideMenu extends React.Component {

  static propTypes = {
    currentPath: PropTypes.string.isRequired,
    clear: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      browserWidth: 0,
      mobileBreakPoint: 960,
      mobileMenuOpen: false,
      mobileStyles: {},
      pageTitle: '',
      modalIsOpen: false
    };

    this.onMenuClick = this.onMenuClick.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.scrollListener = this.scrollListener.bind(this);
    this.toggleSubMenu = this.toggleSubMenu.bind(this);
    this.openModal = this.openModal.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
  }

  componentDidMount () {
    this.setState({
      browserWidth: window.innerWidth
    }, function () {
      if (window.innerWidth < this.state.mobileBreakPoint) {
        this.addListeners();
      }
      window.onresize = this.setMobileListeners.bind(this);
    });
  }

  componentWillUnmount () {
    window.onresize = null;
    this.removeListeners();
  }

  setMobileListeners () {
    if (previousWidth !== window.innerWidth) {
      if (window.innerWidth <= this.state.mobileBreakPoint && previousWidth > this.state.mobileBreakPoint) {
        this.addListeners();
      } else if (window.innerWidth >= this.state.mobileBreakPoint && previousWidth < this.state.mobileBreakPoint) {
        this.removeListeners();
      }
    }

    previousWidth = window.innerWidth;
  }

  addListeners () {
    window.addEventListener('scroll', this.scrollListener, false);
    this.setMaxHeight();
    this.refs.menu.style.display = 'none';
    document.querySelector('body').classList.remove('side-menu-open');
    this.setState({
      mobileMenuOpen: false
    });
  }

  removeListeners () {
    window.removeEventListener('scroll', this.scrollListener, false);
    this.refs.menu.style.maxHeight = 'auto';
    this.refs.menu.style.display = 'block';
  }

  /**
   * On some pages the menu can be higher than the page it self
   * We need to calculate a max height in that case
   */
  setMaxHeight () {
    let headerHeight = document.querySelector('.mobile-header').clientHeight;

    this.setState({
      mobileStyles: {
        maxHeight: window.innerHeight - headerHeight
      }
    });
  }

  scrollListener () {
    let scrollTop = window.scrollY ? window.scrollY : window.pageYOffset;

    if (scrollTop > 100) {
      this.refs.wrapper.classList.add('sticky');
    } else {
      this.refs.wrapper.classList.remove('sticky');
    }
  }

  toggleMenu () {
    this.setState({
      mobileMenuOpen: !this.state.mobileMenuOpen
    }, () => {
      if (this.state.mobileMenuOpen) {
        document.querySelector('body').classList.add('side-menu-open');
        Velocity(this.refs.menu, 'slideDown', {duration: 300});
      } else {
        document.querySelector('body').classList.remove('side-menu-open');
        Velocity(this.refs.menu, 'slideUp', {duration: 300});
      }
    });
  }

  /**
   * On click for sub menu header (economy and settings)
   * Don't toggle the menu when you click on them b
   * stopping propagation to toggleMenu()
   */
  toggleSubMenu (e) {
    e.stopPropagation();
  }

  onMenuClick () {
    if (window.innerWidth <= this.state.mobileBreakPoint) {
      this.toggleMenu();
    }
  }

  destroy () {
    window.removeEventListener('scroll', this.scrollListener, false);
    window.onresize = null;
  }

  onCloseModal () {
    this.setState({
      modalIsOpen: false
    });
  }

  openModal (e) {
    e.preventDefault();

    this.setState({
      modalIsOpen: true
    });
  }

  renderBecomeAmbassadorListItem () {
    return (
      <li>
        <Link to={variables.frontUrl + '/ambassador'} target="_blank" >
          <Translate content='BECOME_AMBASSADOR'/>
        </Link>
      </li>
    );
  }

  renderFindAssignmentListItem () {
    const findAssignmentLink = proxyCounterpart('FIND_ASSIGNMENTS_LINK', {fallback: NO_TRANSLATION});

    if (findAssignmentLink === NO_TRANSLATION) {
      return ('');
    }

    return (
      <li>
        <Link to={proxyCounterpart('FIND_ASSIGNMENTS_LINK')}
          target='_blank'
        >
          <Translate content='FIND_ASSIGNMENTS'/>
        </Link>
      </li>
    );
  }

  render () {
    return (
      <div className='side-menu-wrapper menu-open' ref='wrapper'>
        <div className='mobile-header'>
          <div className='side-menu-title' onClick={this.toggleMenu}>
            <PageTitle />
            <img src={require('images/icons/arrow-down.svg')} />
          </div>
        </div>
        <ul className='side-menu' ref='menu' onClick={this.onMenuClick} style={this.state.mobileStyles}>
          <div className="sidebar_container">
            <h2>
              <Translate content='MY_PAGES'/>
            </h2>
            <li>
              <Link to='/activities' activeClassName='selected' >
                <Translate content='ACTIVITIES'/>
              </Link>
            </li>
            <li >
              <Link to='/economy' activeClassName='selected' onClick={this.toggleSubMenu}>
                <Translate content='MENU_MY_INVOICING'/>
              </Link>
              <ul className='side-sub-menu'>
                <li>
                  <Link to='/economy/invoices' activeClassName='selected' onClick={this.props.clear}>
                    <Translate content='INVOICES'/>
                  </Link>
                </li>
                <li>
                  <Link to='/economy/register-assignment' activeClassName='selected'>
                    <Translate content='MENU_PREREGISTERED_INVOICES' />
                  </Link>
                </li>
                <li>
                  <Link to='/economy/salaries' activeClassName='selected'>
                    <Translate content='SALARIES'/>
                  </Link>
                </li>
                <li>
                  <Link to='/economy/supplier-ledgers' activeClassName='selected'>
                    <Translate content='DEDUCTIONS'/>
                  </Link>
                </li>
                <li>
                  <Link to='/economy/employercertificates' activeClassName='selected'>
                    <Translate content='EMPLOYER_CERTIFICATE'/>
                  </Link>
                </li>
                <li>
                  <Link to='/economy/agreements' activeClassName='selected'>
                    <Translate content='CONTRACTS'/>
                  </Link>
                </li>
                <li>
                  <Link to='/economy/loyalty-program/points' activeClassName='selected'>
                    <Translate content='MENU_LOYALTY_PAGE'/>
                  </Link>
                </li>
                <li>
                  <Link to='/economy/incomestatements' activeClassName='selected'>
                    <Translate content='CONTROL_STATEMENT'/>
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to='/customers' activeClassName='selected'>
                <Translate content='MY_CUSTOMERS'/>
              </Link>
            </li>
            <li>
              <Link to='/settings' activeClassName='selected' onClick={this.toggleSubMenu}>
                <Translate content='SETTINGS'/>
              </Link>
              <ul className='side-sub-menu'>
                <li>
                  <Link to='/settings/personal-information' activeClassName='selected'>
                    <Translate content='PERSONAL_INFO'/>
                  </Link>
                </li>
                <li>
                  <Link to='/settings/salary-information' activeClassName='selected'>
                    <Translate content='SALARY_INFO'/>
                  </Link>
                </li>
                <li>
                  <Link to='/settings/own-employment' activeClassName='selected'>
                    <Translate content='OWN_EMPLOYMENT'/>
                  </Link>
                </li>
                <li>
                  <Link to='/settings/change-password' activeClassName='selected'>
                    <Translate content='CHANGE_PASSWORD'/>
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <div className="menu-divider"></div>
            </li>
            <li>
              <Link to='/faq' activeClassName='selected'>
                <Translate content='FAQ'/>
              </Link>
            </li>
            <li>
              <Link to='/insurances' activeClassName='selected'>
                <Translate content='INSURANCES'/>
              </Link>
            </li>
            <li>
              <Link to='/working-environment' activeClassName='selected'>
                <Translate content='WORKING_ENVIRONMENT'/>
              </Link>
            </li>
            <li>
              <Link to={proxyCounterpart('CHECK_YOUR_WORK_ENVIRONMENT_URL')}
                target="_blank"
              >
                <Translate content='CHECK_YOUR_WORK_ENVIRONMENT'/>
              </Link>
            </li>
            <li>
              <Link to={proxyCounterpart('REPORT_ACCIDENT_LINK')}
                target='_blank'
              >
                <Translate content='REPORT_ACCIDENT'/>
              </Link>
            </li>
            {this.renderBecomeAmbassadorListItem()}
            <li>
              <Link to={{pathname: '/activities', hash: '#calculator-anchor'}}>
                <Translate content='CALCULATOR'/>
              </Link>
            </li>
            <li>
              <Link to='/news' activeClassName='selected'>
                <Translate content='NEWS'/>
              </Link>
            </li>
            {this.renderFindAssignmentListItem()}
          </div>
        </ul>
      </div>
    );
  }
}

export default SideMenu;



/** WEBPACK FOOTER **
 ** ./src/components/left-page-section/side-menu/side-menu.js
 **/